var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.42,
    height: 20,
    viewBox: "0 0 17.42 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FFFFFF;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.35,2H9.65A1.886,1.886,0,0,0,7.76,3.88v.94A1.878,1.878,0,0,0,9.64,6.7h4.71a1.878,1.878,0,0,0,1.88-1.88V3.88A1.871,1.871,0,0,0,14.35,2Z",
    transform: "translate(-3.29 -2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.24,4.82a2.9,2.9,0,0,1-2.89,2.89H9.65A2.9,2.9,0,0,1,6.76,4.82a.747.747,0,0,0-1.1-.65A4.472,4.472,0,0,0,3.29,8.12v9.41A4.481,4.481,0,0,0,7.76,22h8.48a4.481,4.481,0,0,0,4.47-4.47V8.12a4.472,4.472,0,0,0-2.37-3.95A.747.747,0,0,0,17.24,4.82ZM12.38,16.95H8a.75.75,0,0,1,0-1.5h4.38a.75.75,0,0,1,0,1.5Zm2.62-4H8a.75.75,0,0,1,0-1.5h7a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-3.29 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.f3c9653d.svg";
export { ForwardRef as ReactComponent };